import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HeadingText } from '@paypalcorp/pp-react';

export class ConfirmationAmountGiftAid extends Component {
  render() {
    return (
      <HeadingText
        className="text-center"
        style={{ margin: '24px auto' }}
        size="sm"
      >
        {' '}
        + {this.props.extraDonateAmount} {this.props.giftAid}
      </HeadingText>
    );
  }
}

export default ConfirmationAmountGiftAid;

ConfirmationAmountGiftAid.propTypes = {
  extraDonateAmount: PropTypes.string,
  giftAid: PropTypes.string,
};
